import styled, { css } from "styled-components";

import { grayScale } from "@enkor/design/colors";

export const Container = styled.section<{ $isSelectable?: boolean }>`
  position: relative;
  flex: auto;

  padding: 24px 16px 40px;

  background-color: ${grayScale[200]};

  ${({ $isSelectable }) =>
    !$isSelectable
      ? css`
          -moz-user-select: none;
          -ms-user-select: none;
          -khtml-user-select: none;
          -webkit-user-select: none;
          user-select: none;
          -webkit-touch-callout: none;
        `
      : ""}
`;

export const CommentListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const ReplyListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AddCommentButton = styled.button`
  display: flex;
  gap: 4px;
  align-items: center;

  span {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }
`;
